import React from 'react';

import './index.sp.scss';

import SpBasicTemplate from 'components/templates/SpBasicTemplate';
import SpTypeItem from 'components/molecules/SpTypeItem';

import TextAreaBox from 'components/atoms/Input/TextAreaBox';
import PcErrorArea from 'components/molecules/PcErrorArea';

const PresentSP = ({ 
  onClickMainButton,
  valid,
  errorDispMap,
  typeList,
  otherWorkText,
  handleChangeOtherWorkText,
  lpMode,
}) => (
  <div className="OrderType">
    <SpBasicTemplate
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
      valid={valid}
      lpMode={lpMode}
    >
      <div className="sp-wrapper">
        {/* 身体介護・生活援助 */}
        {typeList.map((type)=>{
          const { title, text, typeState, checkState, stateOnChange, allCheckOnChange } = type;
          return(
            <SpTypeItem
              key={title}
              title={title}
              text={text}
              errorDispMap={errorDispMap}
              isAllCheck={checkState}
              allCheckOnChange={allCheckOnChange}
              typeState={typeState}
              stateOnChange={stateOnChange}
              otherWorkText={otherWorkText}
              handleChangeOtherWorkText={handleChangeOtherWorkText}
            />
          );
        })}
        {/* その他 */}
        <div className="sp-otherWork">
          <div className="otherWork-title">その他</div>
          <div className="otherWork-input">
            <TextAreaBox 
              name="otherWorkText"
              value={otherWorkText}
              onChange={handleChangeOtherWorkText}
              placeholder="上記に該当しない業務、および補足事項等"
              maxLength="100"
              inValid={!!errorDispMap.otherWorkText}
            />
          </div>
          <div className='mT5 mL30'>
            <PcErrorArea position='relative' message={errorDispMap.otherWorkText} />
          </div>
          <div className="otherWork-horizon" />
        </div>
      </div>
    </SpBasicTemplate>
  </div>  
);
export default PresentSP;
